(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["silveradda-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('silveradda-carousel')) {
    class SilveraddaCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide-index]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.timer = null;
        this.touchStart = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');

        this.previousButton?.addEventListener('click', () => this.goTo(this.index - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot))));
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
          if (event.key === 'ArrowRight') this.goTo(this.index + 1);
        });
        this.addEventListener('touchstart', (event) => {
          this.touchStart = event.changedTouches[0].clientX;
          this.pause();
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          if (this.touchStart === null) return;
          const distance = event.changedTouches[0].clientX - this.touchStart;
          if (Math.abs(distance) > 45) this.goTo(this.index + (distance < 0 ? 1 : -1));
          this.touchStart = null;
          this.start();
        }, { passive: true });
        this.start();
      }

      disconnectedCallback() {
        this.pause();
      }

      goTo(nextIndex) {
        if (this.slides.length < 2) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          slide.hidden = index !== this.index;
        });
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      start() {
        this.pause();
        if (this.dataset.autoplay !== 'true' || this.reduceMotion || this.slides.length < 2) return;
        const delay = Math.max(Number(this.dataset.delay) || 6000, 3000);
        this.timer = window.setInterval(() => this.goTo(this.index + 1), delay);
      }

      pause() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    }
    customElements.define('silveradda-carousel', SilveraddaCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
